import { useState } from "react"
import { useTranslation } from "react-i18next"
import { t } from "i18next"
import { Form, Panel } from "rsuite"
import { useConverter } from "./EditConverterList"
import { SelectField } from "@/client/components/FormControls"
import { syncTranslation } from "@/client/utils/translate"
import { TValueLabel } from "@/client/utils/types"

interface Settings {
    emptyNull: string,
}

let availableNullEmpty: TValueLabel[] = []
syncTranslation(() => {
    availableNullEmpty = [
        { value: 'project-settings', label: t('Project settings') },
        { value: 'yes', label: t('Yes') },
        { value: 'no', label: t('No') },
    ]
})

export default function ConverterSettings() {
    const { t } = useTranslation()
    const { data, setSettingsHasChanged } = useConverter()
    const [formValue, setFormValue] = useState<Settings>(data?.settings || {})

    function handleOnChange(key: string, value: string): void {
        const newFormValue: any = { ...formValue }
        newFormValue[key] = value
        setFormValue(newFormValue)
        data.settings = newFormValue
        setSettingsHasChanged(value => value + 1)
    }

    return (
        <Panel header={t("Settings")} className="converter-settings">
            <Form
                fluid
                formValue={formValue}
            >
                <SelectField
                    name={"emptyNull"}
                    label={t('Empty NULL Fields')}
                    data={availableNullEmpty}
                    onChange={value => handleOnChange('emptyNull', value)}
                />
            </Form >
        </Panel >
    )
}